import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ObservService {

  constructor() {

  }
  actualizarCarro = new EventEmitter<Number>()
  aceptarTerminos = new EventEmitter<Boolean>()
}
